"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPath = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const providers_1 = require("@mne-core/providers");
const IconComponent_1 = tslib_1.__importDefault(require("../IconComponent"));
const StyledComponents_1 = require("./StyledComponents");
/**
 * Local - Navigation within same SPA (Uses NavLink) eg: /asset/page => /asset/page
 * Internal - Navigation within Argus (Uses toSpaUrl to generate href eg: /asset/page => <domain>.mnemonic.no/spa/asset/page)
 * External - Navigate outside argus (Need to be a full href eg "https://www.webpage.com")
 */
const getComponent = (variant) => {
    switch (variant) {
        /**
         * For local, we want to use NavLink, but "react-router-dom" is not a dependency of mui5.
         * After the beta we need to decide if we want to add "react-router-dom" to this package, or move the menu to a dedicated package.
         */
        case "local":
        case "internal":
        case "external":
        default:
            return "a";
    }
};
/**
 * Return either a `href` or an `to` based on variant.
 *
 * Local returns  `{ to: <path> }` - with the page name stripped form the path.
 * Internal : returns  `{ href: <path> }` - takes path and converts to a SPA URL
 * External : returns  `{ href }` - Noes nothing with the path
 */
const getPath = (href, variant) => {
    switch (variant) {
        case "internal":
            return {
                href: (0, providers_1.toSpaUrl)(href),
            };
        case "local":
            return {
                // Remove first path specification, eg: sample/search/criteria => search/criteria
                to: href.split("/").slice(1).join("/"),
            };
        case "external":
        default:
            return {
                href,
                target: "_blank",
                rel: "noopener noreferrer",
            };
    }
};
exports.getPath = getPath;
const ArgusMenuItem = ({ variant, iconId, href, label, open, hideIcon = false, ...rest }) => {
    return (react_1.default.createElement(StyledComponents_1.ListItem, { key: label, ...rest.ListItemProps },
        react_1.default.createElement(StyledComponents_1.ListItemButton, { ...{ component: getComponent(variant), ...(0, exports.getPath)(href, variant) } },
            !hideIcon && (react_1.default.createElement(StyledComponents_1.ListItemIcon, { ...rest.ListItemIconProps },
                react_1.default.createElement(IconComponent_1.default, { ...{ iconId, fontSize: "small" } }))),
            react_1.default.createElement(StyledComponents_1.ListItemText, { ...{
                    open,
                    primary: label,
                    inset: Boolean(!iconId),
                    primaryTypographyProps: { variant: "body1" },
                    ...rest.ListItemTextProps,
                } }))));
};
exports.default = ArgusMenuItem;
